'use strict';

module.exports = function dd() {
  console.log(this.all());

  if (typeof process !== 'undefined') {
    process.exit(1);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/dd.js
// module id = 1212
// module chunks = 2